The details of the uploaded candidate to be updated.
